export enum EAppLogoNames {
  apl = 'apl',
  itiLight = 'iti-light',
  itiDark = 'iti-dark',
  truckerTmsDark = 'trucker-tms-dark',
  truckerTmsLight = 'trucker-tms-light',
}
